// --------------------------------------------------------------------------------
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Portal } from 'react-portal';
// --------------------------------------------------------------------------------
import Tooltip from 'material-ui/internal/Tooltip';
// --------------------------------------------------------------------------------
import _ from 'lodash';
import { isDefined } from '@Utils/Micro';
// --------------------------------------------------------------------------------
export interface InfotipProps {
    open: boolean;
    content: any;
    xPos: number;
    yPos: number;
    maxWidth?: number;
    horizontalPosition?: 'left' | 'center' | 'right';
    verticalPosition?: 'top' | 'center' | 'bottom';
    style?: React.CSSProperties;
}
// --------------------------------------------------------------------------------
export class Infotip extends React.Component<InfotipProps> {
    // ----------------------------------------------------------------------------
    public static defaultProps: InfotipProps = {
        open: false,
        content: '',
        xPos: 0,
        yPos: 0,
        maxWidth: 300,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        style: {}
    }
    // ----------------------------------------------------------------------------
    constructor(props: InfotipProps) {
        super(props);
    }
    // ----------------------------------------------------------------------------
    render(): JSX.Element | null | false {
        const { horizontalPosition, content, open, yPos, xPos, maxWidth, style, verticalPosition } = this.props;
        return (
            <Portal>
                <Tooltip
                    ref={(ref: Tooltip) => {
                        if (!_.isNull(ref)) {
                            (ReactDOM
                                .findDOMNode(ref) as Element)
                                .querySelector('span')
                                .style
                                .whiteSpace = 'pre-line';
                        }
                    }}
                    horizontalPosition={horizontalPosition}
                    label={content}
                    show={open}
                    style={{
                        zIndex: 5000,
                        top: yPos,
                        left: xPos,
                        maxWidth: isDefined(maxWidth)
                            ? maxWidth : 300,
                        ...style
                    }}
                    touch
                    verticalPosition={verticalPosition}
                />
            </Portal>
        );
    }
}
// --------------------------------------------------------------------------------